import { VideoPlayer } from "../../../../modules/content/components/VideoPlayer/VideoPlayer";
import { DaylightCommonContent } from "../../../../modules/content/components/DaylightCommonContent/DaylightCommonContent";
import { DaylightSection } from "../../../../modules/content/components/DaylightSection/DaylightSection";
import type { IVideoBlockProps } from "./VideoBlock.props";

export const VideoBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  headingEffect,
  parentClass,
  spacing,
  videoBanner,
  videoSource,
  vimeoVideo,
  youtubeVideo,
}: IVideoBlockProps) => {
  const selectedVideo = videoSource === "youtube" ? youtubeVideo : vimeoVideo;
  if (!selectedVideo) return null;
  return (
    <DaylightSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-8 md:gap-12">
        <DaylightCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
          headingEffect={headingEffect}
          reveal
        />
        <div
          className="daylight-work-surface rounded-[28px] p-3 md:p-5"
          data-reveal="stagger"
          data-reveal-enter="focus"
        >
          <VideoPlayer
            banner={videoBanner}
            source={videoSource}
            vimeoVideo={vimeoVideo}
            youtubeVideo={youtubeVideo}
          />
        </div>
      </div>
    </DaylightSection>
  );
};

VideoBlock.displayName = "Block::VideoBlock";
